import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import './Dialogs.scss';

interface OffboardSuccessDialogProps {
  isOpen: boolean;
  participantId: string;
  isRejoining?: boolean;
  onClose: () => void;
}

const OffboardSuccessDialog: React.FC<OffboardSuccessDialogProps> = ({
  isOpen,
  participantId,
  isRejoining = false,
  onClose,
}) => {
  if (!isOpen) return null;

  const title = isRejoining
    ? `${participantId} has successfully been rejoined.`
    : `${participantId} has successfully been offboarded.`;

  const subtitle = isRejoining
    ? 'The participant can now continue with the study and access the application again.'
    : 'The participant will be informed and given instructions on how to proceed in case they want to continue the study.';

  return (
    <Dialog title=" " onClose={onClose} width={500}>
      <div className="offboard-success-dialog">
        <div className="success-checkmark">
          <svg
            width="60"
            height="60"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22,4 12,14.01 9,11.01" />
          </svg>
        </div>
        <p className="success-title">{title}</p>
        <p className="success-subtitle">{subtitle}</p>
      </div>
    </Dialog>
  );
};

export default OffboardSuccessDialog;
